module.exports = require("./so-ET.d.ts");